import {IAction} from '../interface';
import {InferActionsTypes} from '../helpers';
import {IActivityXpedition} from '../activities/interfaces';

export const SET_ACTIVITY_JOURNALS = 'SET_ACTIVITY_JOURNALS';
export const setActivityJournals = (journals: IActivityXpedition[]): IAction<IActivityXpedition[]> => ({
  type: SET_ACTIVITY_JOURNALS,
  payload: journals
});

const actions = {
  setActivityJournals
};

export type ActivityJournalsActionsType = InferActionsTypes<typeof actions>
